import { useState } from "react";

export default function NewsletterSection() {
  const [formStatus, setFormStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formMessage, setFormMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus("loading");
    setFormMessage("");

    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus("success");
      setFormMessage("订阅成功！感谢您的关注！");
      form.reset();
      return;
    }

    const formData = new FormData(form);
    formData.delete("website_alt");

    try {
      const res = await fetch("https://readdy.ai/api/form/d9th1et3pcjqs2fcse5g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed.code === "OK") {
        setFormStatus("success");
        setFormMessage("订阅成功！感谢您的关注！");
        form.reset();
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (errMsg.includes("spam") || errMsg.includes("form data is spam")) {
          setFormStatus("success");
          setFormMessage("订阅成功！感谢您的关注！");
          form.reset();
        } else {
          setFormStatus("error");
          setFormMessage(errMsg || "订阅失败，请稍后重试");
        }
      }
    } catch {
      setFormStatus("error");
      setFormMessage("网络错误，请检查网络后重试");
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-950">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">
          订阅更新通知
        </h2>
        <p className="text-sm text-foreground-400 mb-6">
          第一时间获取最新漫画更新和精彩推荐
        </p>
        <form
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          data-readdy-form=""
          method="POST"
          action="https://readdy.ai/api/form/d9th1et3pcjqs2fcse5g"
          onSubmit={handleSubmit}
        >
          <input
            type="email"
            name="email"
            placeholder="请输入您的邮箱地址"
            required
            className="w-full px-4 py-2.5 rounded-full bg-white/10 text-white placeholder:text-foreground-500 text-sm border border-white/10 focus:outline-none focus:border-accent-500 transition-colors duration-200"
          />
          <button
            type="submit"
            disabled={formStatus === "loading"}
            className="w-full sm:w-auto px-6 py-2.5 bg-accent-500 text-background-950 text-sm font-semibold rounded-full hover:bg-accent-400 transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {formStatus === "loading" ? "发送中..." : "立即订阅"}
          </button>
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
        </form>
        {formMessage && (
          <p className={`mt-3 text-sm ${formStatus === "success" ? "text-green-400" : "text-red-400"}`}>
            {formMessage}
          </p>
        )}
      </div>
    </section>
  );
}